module.exports = __webpack_public_path__ + "files/9ed6114a4b218879ff49ea14beb30814.png";